const toolboxButton = "_61t7u9xci";

export { toolboxButton };
import "./root.toolbox.style.linaria.module.css";
//# sourceMappingURL=root.toolbox.style.js.map
